import React from 'react';
import { decodeHtmlEntities } from '../../config/config-helper';
import { stripHtmlTags } from '../../config/config-helper';

import './Description.css';

const Description = ({ metaDescription}) => {
  return (
    <div className="description">
      {stripHtmlTags(decodeHtmlEntities(metaDescription))}
      <br />
      <br />
    </div>
  );
};

export default Description;
